import api from "../../../services/axiosConfig";

const getExpenses = async (

    params

    // page = 1,

    // itemCount = 20,

    // search,

    // carId,

    // categoryId,

    // fromDate,

    // toDate,

) => {
    
    const { data } = await api.get(

        `/api/Operdon/GetPagingExpense?page=${params.page}&itemCount=${params.pageSize}`,

        {

            params,

        }

    );

    return data;

};

const getExpense = async (id) => {

    const { data } = await api.get(

        `/api/Operdon/GetExpense/${id}`

    );

    return data;

};

const createExpense = async (formData) => {

    const { data } = await api.post(

        "/api/Operdon/ExpensePost",

        formData

    );

    return data;

};

const updateExpense = async (

    id,

    formData

) => {

    const { data } = await api.put(

        `/api/Operdon/EditExpense/${id}`,

        formData

    );

    return data;

};

const deleteExpense = async (id) => {

    const { data } = await api.delete(

        `/api/Operdon/DeleteExpense/${id}`

    );

    return data;

};

const getExpenseCategories = async () => {

    const { data } = await api.get(

        "/api/Category/GetAll/Expense"

    );

    return data;

};

const getgetAttachmentSummary = async () => {

    const { data } = await api.get(

        `/api/Operdon/GetAttachCount`

    );

    return data;

};

const expenseService = {

    getExpenses,

    getExpense,

    createExpense,

    updateExpense,

    deleteExpense,

    getExpenseCategories,

    getgetAttachmentSummary,

};

export default expenseService;